import {computed} from "vue";
import {useRuntimeConfig} from "nuxt/app";

import {useCart} from "./use-cart";
import {
	type SimpleProductDataFragment,
	type ViewCartQuery,
	type CartDataFragment,
	type SimpleProduct,
} from "../graphql";

type CartProduct = CartDataFragment["products"][0]["product"];

type CartRelatedProduct = Extract<
	Extract<
		ViewCartQuery["cart"],
		{__typename: "Cart"}
	>["relatedProductsByCategory"][number]["products"]["edges"][number]["node"],
	{__typename: "SimpleProduct"}
>;

type CartRecommendedProduct = Extract<
	Extract<
		ViewCartQuery["cart"],
		{__typename: "Cart"}
	>["recommendedProducts"][0],
	{__typename: "SimpleProduct"}
>;

type InputProduct =
	| SimpleProductDataFragment
	| SimpleProduct
	| CartProduct
	| CartRelatedProduct
	| CartRecommendedProduct;

interface GaProduct {
	item_id?: string;
	item_name: string;
	item_unique_id: string;
	item_brand?: string;
	price: number;
	quantity: number;
}

export function useGtmValues() {
	const {
		public: {appUrl},
	} = useRuntimeConfig();

	const cart = useCart();

	const productToGa = (product: InputProduct, quantity: number): GaProduct => ({
		item_id: product?.sku ?? undefined,
		item_name: product.name,
		item_unique_id: product.id,
		...(product.brand && {item_brand: product.brand.title}),
		price: Number(product.pricing.price?.amount || "0"),
		quantity,
	});

	const cartValues = computed(() => ({
		cart_ref: cart.id.value || "",
		cart_url: cart.id.value ? `${appUrl}/cart/${cart.id.value}/switch` : "",
	}));

	return {
		cart: cartValues,
		productToGa,
	};
}
